"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Footer = function Footer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      copyright = _ref.copyright,
      copyrightPrepend = _ref.copyrightPrepend,
      copyrightAppend = _ref.copyrightAppend,
      currentYear = _ref.currentYear,
      props = _objectWithoutProperties(_ref, ["className", "children", "copyright", "copyrightPrepend", "copyrightAppend", "currentYear"]);

  var classes = (0, _classnames["default"])('footer', 'uxf-footer', className);
  var copyrightMessage = "".concat(copyrightPrepend, " ").concat(currentYear, " ").concat(copyrightAppend);
  return /*#__PURE__*/_react["default"].createElement("footer", _extends({
    className: classes
  }, props, {
    role: "contentinfo"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-24"
  }, children, copyright && /*#__PURE__*/_react["default"].createElement("span", {
    className: "uxf-footer-legal"
  }, copyrightMessage)))));
};

exports.Footer = Footer;
Footer.propTypes = {
  /**
   * Display copyright with footer
   */
  copyright: _propTypes["default"].bool,

  /**
   * Content that comes before year in copyright
   */
  copyrightPrepend: _propTypes["default"].string,

  /**
   * Content that comes after year in copyright
   */
  copyrightAppend: _propTypes["default"].string,

  /**
   * Year associated with copyright (usually current year)
   */
  currentYear: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Footer.defaultProps = {
  copyright: true,
  copyrightPrepend: 'Copyright ©',
  copyrightAppend: 'Deere & Company. All Rights Reserved.',
  currentYear: new Date().getFullYear()
};